var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caefa-footer"},[_c('div',{attrs:{"id":"fd"}},[_c('p',[_vm._v(" 登记管理机关：中华人民共和国民政部 主管单位：中央社会工作部 ")]),_c('p',[_vm._v("Copyright 2013-2025 中国民族民间工艺美术家协会 ©版权所有")]),_c('p',[_c('a',{attrs:{"href":"http://beian.miit.gov.cn/"}},[_vm._v("京ICP备13028664号")])])]),_c('div',{staticClass:"h20"}),_c('div',{attrs:{"id":"bottom"}})])
}]

export { render, staticRenderFns }